import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Carousel, Row, Col } from 'react-bootstrap'
import BreakPoints from '../../config/BreakPoints'
import BlogItem from '../../pages/LandingPage/components/BlogItem'
import TopicItem from '../../pages/FaqPage/TopicItem'
import OpinionItem from '../Opinions/OpinionItem'
import PushedScamItem from '../../pages/FraudAwarenessPage/PushedScamItem'
import '../../styles/components/OmmCarouselStyle.scss'

const OmmCarousel = ({
  items = [],
  itemsPerSlide = {
    xs: 1,
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4
  },
  space = 3,
  type = undefined,
  slideClass = '',
  itemClass = '',
  variant = 'dark',
  autoSlide = true
}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [itemsArray, setItemsArray] = useState([])
  const [colXs, setColXs] = useState(1)
  const [colSm, setColSm] = useState(1)
  const [colMd, setColMd] = useState(2)
  const [colLg, setColLg] = useState(3)
  const [colXl, setColXl] = useState(4)

  useEffect(() => {
    const updateScreenWidth = () => {
      setScreenWidth(window.innerWidth)
    }
    window.addEventListener('resize', updateScreenWidth)
    return () => {
      window.removeEventListener('resize', updateScreenWidth)
    }
  }, [screenWidth])

  useEffect(() => {
    if (typeof itemsPerSlide === 'number') {
      setColXs(itemsPerSlide)
      setColSm(itemsPerSlide)
      setColMd(itemsPerSlide)
      setColLg(itemsPerSlide)
      setColXl(itemsPerSlide)
    } else {
      setColXs(itemsPerSlide.xs || 1)
      setColSm(itemsPerSlide.sm || colXs || 1)
      setColMd(itemsPerSlide.md || colSm || colXs || 1)
      setColLg(itemsPerSlide.lg || colMd || colSm || colXs || 1)
      setColXl(itemsPerSlide.xl || colLg || colMd || colSm || colXs || 1)
    }
  }, [colLg, colMd, colSm, colXs, itemsPerSlide])

  const spliceIntoChunks = (chunkItems, chunkSize) => {
    const newItemsArray = [...chunkItems]
    const chunkResult = []
    for (let i = 0; newItemsArray.length > 0; i += 1) {
      const chunk = newItemsArray.splice(0, chunkSize)
      chunkResult.push({ id: i, slideItems: chunk })
    }
    return chunkResult
  }

  useEffect(() => {
    if (screenWidth >= BreakPoints.xl) {
      setItemsArray(spliceIntoChunks(items, colXl))
    }
    if (screenWidth >= BreakPoints.lg && screenWidth < BreakPoints.xl) {
      setItemsArray(spliceIntoChunks(items, colLg))
    }
    if (screenWidth >= BreakPoints.md && screenWidth < BreakPoints.lg) {
      setItemsArray(spliceIntoChunks(items, colMd))
    }
    if (screenWidth >= BreakPoints.sm && screenWidth < BreakPoints.md) {
      setItemsArray(spliceIntoChunks(items, colSm))
    }
    if (screenWidth < BreakPoints.sm) {
      setItemsArray(spliceIntoChunks(items, colXs))
    }
  }, [colLg, colMd, colSm, colXl, colXs, items, screenWidth])

  return (
    <Carousel
      indicators={false}
      touch
      wrap
      pause={!autoSlide}
      variant={variant}
      controls={itemsArray?.length > 1}
      className="omm-carousel"
    >
      {itemsArray?.map((rowItems) => (
        <Carousel.Item key={rowItems.id} interval={100000}>
          <Row className={`g-${space} ${slideClass}`} xs={colXs} sm={colSm} md={colMd} lg={colLg} xl={colXl}>
            {rowItems?.slideItems?.map((rowItem) => (
              <Col key={rowItem.id} className={itemClass}>
                {type === 'blog' && <BlogItem blog={rowItem} />}
                {type === 'faqTopic' && <TopicItem topic={rowItem} />}
                {type === 'review' && <OpinionItem opinion={rowItem} />}
                {type === 'pushedScam' && <PushedScamItem scamItem={rowItem} />}
              </Col>
            ))}
          </Row>
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

OmmCarousel.propTypes = {
  items: PropTypes.instanceOf(Array),
  itemsPerSlide: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      xs: PropTypes.number,
      sm: PropTypes.number,
      md: PropTypes.number,
      lg: PropTypes.number,
      xl: PropTypes.number
    })
  ]),
  space: PropTypes.number,
  type: PropTypes.string,
  slideClass: PropTypes.string,
  itemClass: PropTypes.string,
  variant: PropTypes.string,
  autoSlide: PropTypes.bool
}

export default OmmCarousel
